// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"3495":"6193eb13","3527":"532ec94a","3756":"e97c557c","4369":"3e6cb20c","7451":"a6e7c3d5","9430":"a6e7c3d5"}[chunkId] + ".chunk.css";
};